import { createMuiStyles } from '../../../../utils/mui';

export const homeNewsStyles = createMuiStyles({
  headerGrid: {
    mb: 2.5,
    flexWrap: {
      sm: 'nowrap',
    },
    alignItems: {
      xs: 'stretch',
      sm: 'flex-end',
    },
    justifyContent: 'space-between',
    flexDirection: {
      xs: 'column-reverse',
      sm: 'row',
    },
  },
  illustration: {
    margin: 'auto',
    width: 'auto',
    height: {
      xs: '15rem',
      lg: '20rem',
    },
    display: 'block',
  },
  newsImage: {
    display: 'block',
    width: 1,
    height: '30rem',
    borderRadius: 2,
    objectFit: 'cover',
    bgcolor: 'grey.50',
    border: 1,
    borderColor: 'grey.50',
  },
  tabContainer: {
    borderBottom: 1,
    borderColor: 'grey.100',
  },
  dayTab: {
    px: 1,
    minWidth: '3rem',
    minHeight: '2rem',
    py: 0,
    mr: 2.5,
  },
  emptyDataContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    py: 2.5,
  },
  emptyDataIllustration: {
    height: '20rem',
    width: 'auto',
    display: 'block',
  },
});
